export type Country = {
  countryName: string
  countryCode: string
  countryGroup: string
  createdAt: string
  flag: string
  isActive: boolean
  status: boolean
  updatedAt: string
  _id: string
  name: string
}

export type OrderMeta = {
  batch_type: string
  came_from: string
  source: string
  user_status: string
  paid_batch_type: string
  user_cohort: string
  selected_cohort: string
  purchase_day: string
  class_start_date: string
  class_end_date: string
  country_code: string
  user_country: string
  ip: string
}

export type StatusTimeline = {
  status: string
  createdAt: string
  createdBy: string
  _id: string
}

export type RazorPayResponse = {
  amount: number
  amount_due: number
  amount_paid: number
  attempts: number
  created_at: number
  currency: string
  entity: string
  id: string
  notes: {
    orgId: string
    orgName: string
  }
  offer_id: null
  receipt: string
  status: string
}

export type UtmParams = {
  utm_source: string
  utm_medium: string
  utm_campaign: string
  utm_term: string
  utm_content: string
}

export interface OrderModel {
  _id: string
  createdAt: string
  orderByPage: string
  trackingId: string
  AWBNumber: null | string
  courierId: null | string
  deliveryPartner: null | string
  deliveryOrderId: null | string
  reference: null | string
  coinsReferrer: null | number
  price: number
  wallet: number
  cashback: number
  discount: number
  couponDiscount: number
  referrerDiscount: number
  referrerCoinsDiscount: number
  referreCoinsDiscount: number
  gst: number
  deliveryFee: number
  updatedBy: string
  userId: string
  transactionId: null | string
  note: null | string
  organization: string
  couponId: null | string
  formId: null | string
  paymentSource: string
  response: RazorPayResponse
  clientPlatform: string
  clientVersion: string
  address: null | string
  extendedParams: {
    utmParams: UtmParams
  }
  pathshala: null | string
  billingAddress: null | string
  gstin: null | string
  status: string
  slots: string[]
  pwStoreOrderId: null | string
  statusTimeline: StatusTimeline[]
  currency: string
  vat: number
  integratedWith: null | string
  isRetry: boolean
  sahajTransactionId: null | string
  revenueAttribution: null | string
  isUpgradePremium: boolean
  isLevelUp: boolean
  donationAmount: null | number
  donationStatus: null | string
  erpOrderId: null | string
  reconcile: boolean
  reconcileCount: number
  meta: OrderMeta
  couponVersion: number
  loanDetails: null | string
  sourceTransactionId: null | string
  isParentOrder: boolean
  upgradedFrom: null | string
  orderFinancialId: null | string
  scholarshipId: null | string
  isSIsetUp: boolean
  taxationState: string
  taxationStateSource: string
  updatedAt: string
  __v: number
}

export type FeeIdModel = {
  userId: string
  batchId: string
  batches: []
  amount: number
  discount: number
  adjustmentDiscount: number
  adjustedBatchIds: []
  cashback: number
  gst: number
  submissionDate: string
  installmentNumber: number
  status: string
  vat: number
  currency: string
  paymentType: string
  isRenew: boolean
  ezpayEmiStatus: string
  _id: string
  createdAt: string
  updatedAt: string
  planItems: []
  partialPayments: []
  __v: number
}

export type CohortModel = {
  _id: string
  name: string
  filters: {
    classes: string[]
    boards: string[]
    courses: string[]
    status: string[]
    languages: string[]
    streams: string[]
    subExams: string[]
    _id: string
  }
  board: string
  class: string
  exam: string
  createdAt: string
  icon: string
  language: string
  organizationId: string
  previewTextTitle: string
  programs: string[]
  relevantCohorts: string[]
  status: string
  stream: string
  subExam: string
  tags: string[]
  updatedAt: string
}

export type AppOtplessConfig = {
  appId: string
  enabled: boolean
  env: string
  isSmsEnabled: boolean
  isTrueCallerEnabled: boolean
  isWhatsAppEnabled: boolean
  otpLength: number
  platform: string
  resendTimer: 60
}

export enum UserType {
  Free = 'Free',
  Demo = 'Demo',
  Master = 'Master',
}
